import React, { useState, useEffect, useMemo, useRef } from 'react';
import Vn from '../vn/vn';
import BlackScreen from '../blackScreen/blackScreen';
import Test from '../test/test';
import MasturbationGame from '../masturbationGame/masturbationGame';
import GroupChat from '../groupChat/groupChat';
import Chat from '../chat/chat';
import plot from'../../services/plot'
import plotRu from'../../services/plotRu'
import {IsLSWork} from '../app/app'

function Play({step, state, setStep, goMenu, achievementsSave, gallerySC, phoebesComfort, achievementCondition, language, hzAdjuster}) {
  const [isLS, setIsLS] = useState(IsLSWork());
  const [plotLine, setPlotLine] = useState( isLS ? localStorage.getItem('plotLineSC') === null? 0 : parseInt(localStorage.getItem('plotLineSC')) : 0);
  let chosenPlot;

  useMemo(() => {
    if(language == "en"){
      chosenPlot = plot;
    }else if(language == "ru"){
      chosenPlot = plotRu;
    }
  });

  function goNext(i){
    if(i == undefined){
    if(isLS){
    localStorage.setItem('stepSC1', step+1);
  }
    setStep(prev => prev+1);
  }else{
    if(isLS){
    localStorage.setItem('stepSC1', step+i);
  }
    setStep(prev => prev+i);
  }
  }


  if(chosenPlot[step]["novel"]){
    return(
    <Vn goMenu={goMenu} state={state} plot={chosenPlot[step]["script"]} isLS={isLS} background={chosenPlot[step]["background"]} saveStart={chosenPlot[step]["saveStart"]} step={step} goNext={goNext} startCoordinates={chosenPlot[step]["startCoordinates"]} achievementsSave={achievementsSave} gallerySC={gallerySC} phoebesComfort={phoebesComfort} achievementCondition={achievementCondition} language={language} hzAdjuster={hzAdjuster} key={step}/>
    );
  }
  if(chosenPlot[step]["masturbationGame"]){
    return(
    <MasturbationGame goMenu={goMenu} isLS={isLS} goNext={goNext} state={state} step={step} achievementsSave={achievementsSave} language={language} hzAdjuster={hzAdjuster} key={step}/>
    );
  }
  if(chosenPlot[step]["chat"]){
    return(
    <Chat from={chosenPlot[step].from} mess={chosenPlot[step].messages} state={state} step={step} isLS={isLS} goMenu={goMenu} isLS={isLS} goNext={goNext} hzAdjuster={hzAdjuster} gallerySC={gallerySC} language={language} key={step}/>
    );
  }
  if(chosenPlot[step]["groupChat"]){
    return(
    <GroupChat from={chosenPlot[step].from} mess={chosenPlot[step].messages} state={state} step={step} isLS={isLS} goMenu={goMenu} isLS={isLS} goNext={goNext} hzAdjuster={hzAdjuster} gallerySC={gallerySC} language={language} key={step}/>
    );
  }
  if(chosenPlot[step]["test"]){
    return(
    <Test goMenu={goMenu} questionsArr={chosenPlot[step]["questions"]} isLS={isLS} goNext={goNext} state={state} step={step} achievementsSave={achievementsSave} language={language} hzAdjuster={hzAdjuster} key={step}/>
    );
  }
  if(chosenPlot[step]["afterTest"]){
    let result;
    if(state.current[step-1]["testResult"] == 0){
      result = "resultAA";
    }else if(state.current[step-1]["testResult"] == 1){
      result = "resultA";
    }else if(state.current[step-1]["testResult"] == 2 ){
      result = "resultB";
    }else if(state.current[step-1]["testResult"] == 3){
      result = "resultC";
    }else if(state.current[step-1]["testResult"] >= 4){
      result = "resultD";
    }
    if(state.current[step-1]["specialQuestion"]){
      if((state.current[step-1]["specialQuestion"] == "a" || state.current[step-1]["specialQuestion"] == "b") && result !== "resultAA"){
        chosenPlot[step][result] = chosenPlot[step][result].concat(chosenPlot[step]["answeredSpecialQuestion"]);
      }else if((state.current[step-1]["specialQuestion"] == "a" || state.current[step-1]["specialQuestion"] == "b") && result == "resultAA"){
        chosenPlot[step][result] = chosenPlot[step][result].concat(chosenPlot[step]["answeredSpecialQuestionAroused"]);
      }
    }
    if(result !== "resultAA"){
      chosenPlot[step][result] = chosenPlot[step][result].concat(chosenPlot[step]["ending"]);
    }else if(result == "resultAA"){
      chosenPlot[step][result] = chosenPlot[step][result].concat(chosenPlot[step]["endingAroused"]);
    }

    return(
    <Vn goMenu={goMenu} state={state} plot={chosenPlot[step][result]} isLS={isLS} background={chosenPlot[step]["background"]} saveStart={chosenPlot[step]["saveStart"]} step={step} goNext={goNext} startCoordinates={chosenPlot[step]["startCoordinates"]} achievementsSave={achievementsSave} gallerySC={gallerySC} phoebesComfort={phoebesComfort} achievementCondition={achievementCondition} language={language} hzAdjuster={hzAdjuster} key={step}/>
    );
  }
  if(step !== undefined && chosenPlot[step]["blackScreen"]){
    return (
      <BlackScreen goMenu={goMenu} txt={chosenPlot[step]["txt"]} end={chosenPlot[step]["end"]} trailer={chosenPlot[step]["trailer"]} goNext={goNext} step={step} state={state} setStep={setStep} hzAdjuster={hzAdjuster}/>
  );
  }

}

export default Play;
